import { ofType } from 'redux-observable';

import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { types as actions, setRpDetailAction } from '../../reducers/actions';
import { ReferencePointService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_RP_DETAIL),
    switchMap(action =>
      ReferencePointService.getAll(action.siteId, store).pipe(
        map(data => {
          return setRpDetailAction(data);
        })
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/status/getReferencePoint.js